import React from 'react';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import HeroBlock from '../hero';
import ButtonsRow from '../buttons/buttons-row';
import CardContainer from '../card-container';
import RichContentContainer from '../rich-content-container';
import Slider from '../slider';
import Grid from '../grid';
import ImageBanner from '../image-banner';
import ImageText from '../image-text';
import IframeBlock from '../iframe/iframe';
import Download from '../downloads/download'

const CustomBlockAssigner = ({ block, blockIndex, pageType }) => {
    switch(block?.internal?.type) {
        case "ContentfulRichContent":
            return <RichContentContainer block={ block } />
        case "ContentfulButtonList":
            return block?.linkList && block?.linkList.length > 0 && <ButtonsRow links={block?.linkList} buttonsStyle={block?.buttonsStyle} />
        case "ContentfulImage":
            return <GatsbyImage image={getImage(block?.image)} alt={`${block?.alt}`} />;
        case "ContentfulCardContainer":
            return <CardContainer cards={block} blockIndex={blockIndex} />
        case "ContentfulHeroBlock":
            return <HeroBlock {...block} pageType={pageType} />
        case "ContentfulSlider":
            return <Slider slides={block.slide} blockIndex={blockIndex} />
        case "ContentfulGrid":
            return <Grid gridItems={block?.gridItem} blockIndex={blockIndex} />
        case "ContentfulImageBanner":
            return <ImageBanner {...block} />
        case "ContentfulImageTextBlock":
            return <ImageText {...block} />
        case "ContentfulIframe":
            return <IframeBlock iframe={block} />
        case "ContentfulFile":
            return <Download title={block?.title} files={block?.files} halfWidth={false} />
    }
}

export default CustomBlockAssigner;